import { useEffect, useRef } from "react";
import { JudgeMessaging } from "./JudgeMessaging";
import { RunSheet } from "@/components/run/RunSheet";
import { useOfficialWrite, type OfficialSheetProps } from "./shared";
export function ConfirmAction(
  props: OfficialSheetProps & {
    title: string;
    path: string;
    kind: string;
    body: unknown;
    method?: "post" | "put";
  },
) {
  const { busy, error, write, execute, undo } = useOfficialWrite(props);
  const requiresConfirmation =
    props.kind === "unrelease" ||
    (props.kind === "release" && !!(props.body as { all?: boolean }).all);
  const started = useRef(false);
  useEffect(() => {
    if (!requiresConfirmation && !started.current && !busy) {
      started.current = true;
      void write(() => execute(props.kind, props.body));
    }
  }, [requiresConfirmation, busy, write, execute, props.kind, props.body]);
  const count = props.heat.riders
    .flatMap((r) => r.attempts)
    .filter(
      (a) => !a.released && !["superseded", "reride_pending", "reverted"].includes(a.status),
    ).length;

  return (
    <RunSheet title={props.title} close={props.onClose}>
      {requiresConfirmation && (
        <p>
          {props.kind === "release"
            ? `${count} unreleased ${count === 1 ? "attempt" : "attempts"} will be published.`
            : `Confirm ${props.title.toLowerCase()} for ${props.heat.name}.`}
        </p>
      )}
      {error && <p role="alert">{error}</p>}
      {undo}
      {requiresConfirmation && (
        <button
          className="run-primary"
          disabled={busy}
          onClick={() => void write(() => execute(props.kind, props.body))}
        >
          {props.title}
        </button>
      )}
      <button onClick={props.onClose}>{requiresConfirmation ? "Cancel" : "Close"}</button>
    </RunSheet>
  );
}
export function MessageSheet(props: OfficialSheetProps) {
  return (
    <RunSheet title="Message judges" close={props.onClose}>
      <JudgeMessaging
        competitionId={props.competitionId}
        heatId={props.heat.id}
        transport={props.transport}
      />
    </RunSheet>
  );
}
